import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'

Vue.config.productionTip = false
axios.defaults.withCredentials = true
axios.defaults.baseURL = 'http://app.slack.o3industries.se/'
axios.defaults.headers = {
  'Access-Control-Allow-Origin': '*',
  'Content-type': 'application/json',
}

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
